import { APP_CONFIG } from '../config/appConfig.js';
import { authService } from '../services/authService.js';
import { openAuthModal } from './AuthModal.js';

export function createHeader({ onSearchClick, onBackClick, showBack = false }) {
  const header = document.createElement('header');
  header.className = 'app-header';

  const user = authService.getCurrentUser();
  const isAdmin = authService.isAdmin();

  const backBtnHtml = showBack
    ? `<button id="header-back-btn" class="icon-btn clickable-item" aria-label="Go Back">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>`
    : '';

  const authBtnHtml = user
    ? `<a href="#/account" class="badge-pill clickable-item ${isAdmin ? 'badge-gold' : 'badge-cyan'}" style="padding: 6px 12px; font-size: 0.8rem; display: flex; align-items: center; gap: 6px;">
        <span>${isAdmin ? '👑' : '👤'}</span>
        <span style="max-width: 90px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${user.name.split(' ')[0]}</span>
      </a>`
    : `<button id="header-login-btn" class="btn-primary clickable-item" style="padding: 6px 14px; font-size: 0.8rem;">
        Sign In
      </button>`;

  header.innerHTML = `
    <div style="display: flex; align-items: center; gap: 12px;">
      ${backBtnHtml}
      <a href="#/" class="brand-wrapper">
        <div class="brand-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
            <line x1="7" y1="2" x2="7" y2="22"></line>
            <line x1="17" y1="2" x2="17" y2="22"></line>
            <line x1="2" y1="12" x2="22" y2="12"></line>
          </svg>
        </div>
        <div>
          <span class="brand-name">${APP_CONFIG.appName}</span>
          <span class="brand-sinhala">${APP_CONFIG.sinhalaName}</span>
        </div>
      </a>
    </div>

    <nav class="desktop-nav">
      <a href="#/" class="desktop-nav-link">Home</a>
      <a href="#/songs" class="desktop-nav-link">Soundtracks</a>
      <a href="#/locations" class="desktop-nav-link">Locations</a>
      <a href="#/watchlist" class="desktop-nav-link">Watchlist</a>
      ${isAdmin ? '<a href="#/admin" class="desktop-nav-link badge-gold" style="color: var(--accent-gold);">+ Add Data</a>' : ''}
    </nav>

    <div class="header-actions">
      <button id="header-search-btn" class="icon-btn clickable-item" aria-label="Search Movies & Cast">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </button>
      ${authBtnHtml}
    </div>
  `;

  const searchBtn = header.querySelector('#header-search-btn');
  if (searchBtn && onSearchClick) {
    searchBtn.addEventListener('click', onSearchClick);
  }

  const backBtn = header.querySelector('#header-back-btn');
  if (backBtn && onBackClick) {
    backBtn.addEventListener('click', onBackClick);
  }

  const loginBtn = header.querySelector('#header-login-btn');
  if (loginBtn) {
    loginBtn.addEventListener('click', () => {
      openAuthModal(() => {
        window.location.hash = '#/account';
        window.location.reload();
      });
    });
  }

  return header;
}
